var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 244,
    viewBox: "0 0 318 244",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 141,
    width: 42,
    height: 30,
    rx: 15,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.96 10.624V19H155.28V13.552L153.036 19H151.764L149.508 13.552V19H147.828V10.624H149.736L152.4 16.852L155.064 10.624H156.96ZM161.573 19.108C160.933 19.108 160.357 18.968 159.845 18.688C159.333 18.4 158.929 17.996 158.633 17.476C158.345 16.956 158.201 16.356 158.201 15.676C158.201 14.996 158.349 14.396 158.645 13.876C158.949 13.356 159.361 12.956 159.881 12.676C160.401 12.388 160.981 12.244 161.621 12.244C162.261 12.244 162.841 12.388 163.361 12.676C163.881 12.956 164.289 13.356 164.585 13.876C164.889 14.396 165.041 14.996 165.041 15.676C165.041 16.356 164.885 16.956 164.573 17.476C164.269 17.996 163.853 18.4 163.325 18.688C162.805 18.968 162.221 19.108 161.573 19.108ZM161.573 17.644C161.877 17.644 162.161 17.572 162.425 17.428C162.697 17.276 162.913 17.052 163.073 16.756C163.233 16.46 163.313 16.1 163.313 15.676C163.313 15.044 163.145 14.56 162.809 14.224C162.481 13.88 162.077 13.708 161.597 13.708C161.117 13.708 160.713 13.88 160.385 14.224C160.065 14.56 159.905 15.044 159.905 15.676C159.905 16.308 160.061 16.796 160.373 17.14C160.693 17.476 161.093 17.644 161.573 17.644ZM167.953 10.12V19H166.273V10.12H167.953ZM169.181 15.652C169.181 14.98 169.313 14.384 169.577 13.864C169.849 13.344 170.217 12.944 170.681 12.664C171.145 12.384 171.661 12.244 172.229 12.244C172.661 12.244 173.073 12.34 173.465 12.532C173.857 12.716 174.169 12.964 174.401 13.276V10.12H176.105V19H174.401V18.016C174.193 18.344 173.901 18.608 173.525 18.808C173.149 19.008 172.713 19.108 172.217 19.108C171.657 19.108 171.145 18.964 170.681 18.676C170.217 18.388 169.849 17.984 169.577 17.464C169.313 16.936 169.181 16.332 169.181 15.652ZM174.413 15.676C174.413 15.268 174.333 14.92 174.173 14.632C174.013 14.336 173.797 14.112 173.525 13.96C173.253 13.8 172.961 13.72 172.649 13.72C172.337 13.72 172.049 13.796 171.785 13.948C171.521 14.1 171.305 14.324 171.137 14.62C170.977 14.908 170.897 15.252 170.897 15.652C170.897 16.052 170.977 16.404 171.137 16.708C171.305 17.004 171.521 17.232 171.785 17.392C172.057 17.552 172.345 17.632 172.649 17.632C172.961 17.632 173.253 17.556 173.525 17.404C173.797 17.244 174.013 17.02 174.173 16.732C174.333 16.436 174.413 16.084 174.413 15.676Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M161.5 35L158.469 29.75L164.531 29.75L161.5 35Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M315.451 46.6309H251.858V68.64L279.576 78.4202V212.946L251.858 222.726V242.294H317.081L315.451 46.6309Z",
    fill: "url(#paint0_linear_4266_4344)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M315.451 46.6309H251.858V68.64L279.576 78.4202V212.946L251.858 222.726V242.294H317.081L315.451 46.6309Z",
    fill: "#FF0000",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.796589 45V82.2178L30.0929 95.9661V189.461L0 210.769L1.65953 243.111H30.9558V208.055H58.5262V90.6556L30.9558 81.6868V45H0.796589Z",
    fill: "url(#paint1_linear_4266_4344)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.796589 45V82.2178L30.0929 95.9661V189.461L0 210.769L1.65953 243.111H30.9558V208.055H58.5262V90.6556L30.9558 81.6868V45H0.796589Z",
    fill: "#374BFF",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4266_4344",
    x1: 251.858,
    y1: 144.462,
    x2: 317.081,
    y2: 144.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4266_4344",
    x1: 0,
    y1: 144.056,
    x2: 58.5262,
    y2: 144.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#CFCBC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A8A8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#697071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#465053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#878D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#B7B9BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D4D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#BCBFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#91989D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#8B9298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMold);
export default __webpack_public_path__ + "static/media/Mold.a4889d8c6ddbe73df2a33aa7296dc751.svg";
export { ForwardRef as ReactComponent };